module.exports = __webpack_public_path__ + "static/media/focus2.95b5f72c.jpg";